module.exports = __webpack_public_path__ + "img/join-us.ca7d331c.jpg";